import moneyTagIcon from "../../../assets/svg/money-tag 6.svg";
import { OperatorProfile_API } from "../../../api/endpoints";

export const endpoint = OperatorProfile_API;
export const operatorSearch = "operator/operator-profiles-search/";
export const OPERATOR_OVERVIEW_DASHBOARD_ENDPOINT = "dashboard/operator-overview-dashboard/";
export const MONEY_TAG_ICON_URL = moneyTagIcon;

export const OPERATOR_TYPE_FILTER_OPTIONS = [
  { value: "ALL", label: "ALL" },
  { value: "Domestic", label: "Domestic" },
  { value: "International", label: "International" },
];

export const resolveOperatorType = (item) =>
  String(item?.operator_type ?? item?.type ?? "").trim();

export const formatOperatorTypeLabel = (item) => {
  const raw = resolveOperatorType(item);
  if (!raw) return "—";
  const lower = raw.toLowerCase();
  if (lower.includes("international")) return "International";
  if (lower.includes("domestic")) return "Domestic";
  return raw;
};

export const matchesOperatorTypeFilter = (item, filter) => {
  if (!filter || filter === "ALL") return true;
  const type = resolveOperatorType(item).toLowerCase();
  if (filter === "Domestic") return type.includes("domestic");
  if (filter === "International") return type.includes("international");
  return type === filter.toLowerCase();
};

export const formatMoney = (value) => {
  const amount = Number(value) || 0;
  return amount.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatRevenue = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value.toLocaleString("en-IN");
  }
  const text = String(value ?? "").trim().replace(/^\$\s*/, "");
  return text || "0";
};

export const formatRevenueYearly = (value) => {
  const text = formatRevenue(value);
  return text.includes("/ year") ? text : `${text} / year`;
};

/** Normalizes API rows for the operators DataTable (used with DataWrapper). */
export const mapOperatorListRows = (rows) => {
  if (!Array.isArray(rows) || !rows.length) return [];
  return rows.map((item, index) => ({
    id: item?.id ?? index + 1,
    uuid: item?.uuid,
    operator_name: item?.operator_name || "Unknown Operator",
    operator_type: formatOperatorTypeLabel(item),
    logo: item?.logo,
    wallet_balance:
      Number(item?.wallet_balance ?? item?.wallet ?? item?.wallet_amount) || 0,
    policies: Number(item?.policies_count ?? item?.policy_count) || 0,
    revenue: formatRevenueYearly(item?.revenue),
    logoSpec: item?.logoSpec,
    status:
      item?.status ||
      (item?.is_active === false ? "Suspended" : "Active"),
  }));
};

export const operatorPaymentsFilterOptions = [
  {
    label: "Gateway",
    value: "gateway",
    type: "checkbox",
    options: [
      { value: "RAZORPAY", label: "Razorpay" },
      { value: "STRIPE", label: "Stripe" },
      { value: "PAYU", label: "PayU" },
    ],
  },
  {
    label: "Currency",
    value: "currency",
    type: "checkbox",
    options: [
      { value: "INR", label: "INR" },
      { value: "USD", label: "USD" },
    ],
  },
  {
    label: "Status",
    value: "transaction_status",
    type: "checkbox",
    options: [
      { value: "SUCCESS", label: "Success" },
      { value: "COMPLETED", label: "Completed" },
      { value: "FAILED", label: "Failed" },
      { value: "PENDING", label: "Pending" },
    ],
  },
];

export const operatorTripsFilterOptions = [
  {
    label: "Cover Type",
    value: "cover_type",
    type: "checkbox",
    options: [
      { value: "Domestic", label: "Domestic" },
      { value: "International", label: "International" },
      { value: "Family", label: "Family" },
      { value: "Student", label: "Student" },
    ],
  },
  {
    label: "Status",
    value: "policy_status",
    type: "checkbox",
    options: [
      { value: "Active", label: "Active" },
      { value: "Pending", label: "Pending" },
      { value: "Cancelled", label: "Cancelled" },
      { value: "Expired", label: "Expired" },
    ],
  },
];

export const operatorTravellersFilterOptions = [
  {
    label: "Cover Type",
    value: "cover_type",
    type: "checkbox",
    options: [
      { value: "Domestic", label: "Domestic" },
      { value: "International", label: "International" },
      { value: "Family", label: "Family" },
      { value: "Student", label: "Student" },
    ],
  },
];
